<template>

    <Report heading="Продажби по артикули" resource="/stock-sales" ref="report">

        <template v-slot:body="props">

        <table v-if="props.data.items">
            <thead>
                <tr>
                    <th colspan="2">Артикул</th>
                    <th rowspan="2">Количество</th>
                    <th colspan="2">Покупна</th>
                    <th colspan="4">Продажна</th>
                    <th rowspan="2">Печалба</th>
                </tr>
                <tr>
                    <th>Номер</th>
                    <th>Наименование</th>
                    <th>Цена</th>
                    <th>Стойност</th>
                    <th>Цена</th>
                    <th>Стойност</th>
                    <th>ДДС</th>
                    <th>Общо</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in props.data.items" :key="item">
                    <td class="number">{{item.number}}</td>
                    <td>{{item.name}}</td>
                    <td class="right number">{{item.quantity}}</td>
                    <td class="right number">{{$utils.currency(item.purchase.price)}}</td>
                    <td class="right number">{{$utils.currency(item.purchase.amount)}}</td>
                    <td class="right number">{{$utils.currency(item.sales.price)}}</td>
                    <td class="right number">{{$utils.currency(item.sales.amount)}}</td>
                    <td class="right number">{{$utils.currency(item.sales.vat)}}</td>
                    <td class="right number">{{$utils.currency(item.sales.total)}}</td>
                    <td class="right number">{{$utils.currency(item.profit)}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2" class="right">Общо:</th>
                    <th>&nbsp;</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.purchase.amount)}}</th>
                    <th>&nbsp;</th>
                    <th class="right number">{{$utils.currency(props.data.total.sales.amount)}}</th>
                    <th class="right number">{{$utils.currency(props.data.total.sales.vat)}}</th>
                    <th class="right number">{{$utils.currency(props.data.total.sales.total)}}</th>
                    <th class="right number">{{$utils.currency(props.data.total.profit)}}</th>
                </tr>
            </tfoot>
        </table>
        <br/>&nbsp;

        </template>
    </Report>

</template>

<script>

export default {
    data() {
        return {
        }
    },

    methods: {
    },

    computed: {
    }

}

</script>

<style>

.rpt {
    border-collapse: collapse;
    margin: auto;
}

.rpt td, .rpt th {
    border: 1px solid grey;
    padding: .3em;
}

.number {
    width: 7em;
}

</style>
